module.exports = __webpack_public_path__ + "img/vtv-sbt.459ba7a9.png";